import dayjs from 'dayjs';
import 'dayjs/locale/zh-tw';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import { DAYJS_LOCALE } from '@/config/dateTime';
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(isSameOrAfter);
dayjs.locale(DAYJS_LOCALE);
/**
 * @example
 * input: { dateTime: '2021-01-01T00:00:00.000Z', format: 'YEAR_DATE_TIME' }
 * output: { parsedDateTime: '2021/1/1(五) 08:00' }
 * @example
 * input: { dateTime: '2021-01-01T00:00:00.000Z', format: 'YEAR_DATE_TIME_WITHOUT_DAY' }
 * output: { parsedDateTime: '2021-01-01 08:00' }
 */
export const getParsedDateTime = ({ dateTime, format, }) => {
    const parsedDateTime = dayjs(dateTime).format(format);
    return { parsedDateTime };
};
/**
 * @example
 * input: { timeA: '2021-01-01T00:00:00.000Z', timeB: '2021-01-01T00:00:00.000Z' }
 * output: true
 * @example
 * input: { timeA: '2021-01-01T00:00:00.000Z', timeB: '2021-01-11T00:00:00.000Z' }
 * output: false
 */
export const getIsTimeASameOrAfterTimeB = ({ timeA, timeB }) => {
    const isTimeASameOrAfterTimeB = dayjs(timeA).isSameOrAfter(dayjs(timeB));
    return isTimeASameOrAfterTimeB;
};
